module.exports = require("./th.d.ts");